// extracted by mini-css-extract-plugin
export default {"logout":"logout-button_logout__PvbEq","icon":"logout-button_icon__A9jfC"};